export const loadSessionStorageState = (stateKey: string) => {
	if (!__IS_SERVER__) {
		try {
			const data = sessionStorage?.getItem(stateKey);
			if (!data) {
				return null;
			}
			return JSON.parse(data);
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e);
			return null;
		}
	}
	return null;
};

export const saveSessionStorageState = <T>(key: string, data: T) => {
	if (!__IS_SERVER__) {
		try {
			const stringifiedData = JSON.stringify(data);
			sessionStorage?.setItem(key, stringifiedData);
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e);
		}
	}
};
